import React from 'react'
import { useLocalLabels } from '@sentecacommerce-theme/lib'
import { FavoritesLabels } from '../../favorites.props'
import { EmptyBasketAndWishlist } from '../../../Common/EmptyBasketAndWishlist'

export const EmptyWishlist = () => {
  const labels = useLocalLabels<FavoritesLabels>()
  return (
    <EmptyBasketAndWishlist
      emptyBasketOrWishlistText={labels?.emptyWishlistText}
      emptyBasketOrWishlistCallToAction={labels?.emptyWishlistCallToAction}
    />
  )
}
